import { render, staticRenderFns } from "./BarcodeFabric.vue?vue&type=template&id=079ff434&scoped=true&"
import script from "./BarcodeFabric.vue?vue&type=script&lang=js&"
export * from "./BarcodeFabric.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeFabric.vue?vue&type=style&index=0&id=079ff434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ff434",
  null
  
)

export default component.exports